<script setup lang="ts">
import MenuEntryTitle from '@components/menu/menu-entry-title.vue';
import { type NavigationEntry } from './navigation';
import { type ResolvedRoute } from '@router/interfaces/resolved-route';

defineProps<{
    entry: NavigationEntry,
    route: ResolvedRoute|null,
    active: boolean,
    selected: boolean,
    hasChildren: boolean,
    activeSearch: boolean,
}>();

const emit = defineEmits<{
    (event: 'toggle', entry: NavigationEntry): void,
}>();
</script>

<template>
    <MenuEntryTitle
        :title="entry.title"
        :route="route ?? undefined"
        :menu-level="entry.level"
        :selected="selected"
        :active="active"
        :has-no-children="!hasChildren"
        :active-search="activeSearch"
        @click="emit('toggle', entry)"
    />
</template>
